import { render, staticRenderFns } from "./SuperiorSpirit.vue?vue&type=template&id=1cd678dc&scoped=true"
import script from "./SuperiorSpirit.vue?vue&type=script&lang=js"
export * from "./SuperiorSpirit.vue?vue&type=script&lang=js"
import style0 from "./SuperiorSpirit.vue?vue&type=style&index=0&id=1cd678dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd678dc",
  null
  
)

export default component.exports